module.exports = __webpack_public_path__ + "img/az.17e8e519.svg";